import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgToilet = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#85E3F9"
      d="M13.41 6h13.18A1.41 1.41 0 0 1 28 7.41V18H12V7.41A1.41 1.41 0 0 1 13.41 6"
    />
    <path
      fill="#00C5F2"
      d="M12 18h16a2 2 0 0 1 2 2H10a2 2 0 0 1 2-2"
    />
    <path
      fill="#85E3F9"
      fillRule="evenodd"
      d="M30 20H10a10 10 0 0 0 4.89 8.58 1.16 1.16 0 0 1 .58 1.16l-.6 4.26h10.26l-.6-4.26a1.16 1.16 0 0 1 .58-1.16A10 10 0 0 0 30 20"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M28.577 8.675a1.4 1.4 0 0 0-.562-.095H24v-1h3.993A2.44 2.44 0 0 1 30.5 9.995v2.155h-1v-2.147a1.44 1.44 0 0 0-.923-1.328M12.65 27.264A10.34 10.34 0 0 1 9.5 20.01l1-.018a9.34 9.34 0 0 0 9.492 9.18l.016.999c-2.74.045-5.387-1-7.357-2.906"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgToilet);

export default ForwardRef;
